export default __webpack_public_path__ + "static/media/fi2.cbb6f35c.svg";